module.exports = __webpack_public_path__ + "img/@emoji_smile.55c45b2c.png";